import { motion } from "framer-motion";
import { PhoneFrame } from "./ProjectMockups";

const bars = [62, 40, 78, 55, 30, 68];

export const HeroMockup = () => (
  <div className="relative w-full max-w-md mx-auto lg:mx-0 h-[400px] sm:h-[460px] lg:h-[500px]" data-testid="hero-visual-mockup">
    <div className="absolute -top-8 -right-4 h-56 w-56 rounded-full bg-electric/25 blur-3xl" />
    <div className="absolute bottom-4 -left-8 h-48 w-48 rounded-full bg-laser/20 blur-3xl" />

    <motion.div
      initial={{ opacity: 0, y: 24, rotate: -2 }}
      animate={{ opacity: 1, y: 0, rotate: -2 }}
      transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="absolute left-0 top-4 sm:top-8 w-[74%] rounded-2xl border border-border-subtle bg-card-dark/90 backdrop-blur-xl shadow-2xl shadow-black/50"
    >
      <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-border-subtle">
        <span className="h-2 w-2 rounded-full bg-red-500/70" />
        <span className="h-2 w-2 rounded-full bg-yellow-500/70" />
        <span className="h-2 w-2 rounded-full bg-emerald-500/70" />
        <div className="ml-2 h-4 flex-1 rounded-md bg-white/5 text-[8px] text-slate-500 flex items-center px-2 font-mono">
          dotnetservices / dashboard
        </div>
      </div>
      <div className="p-4">
        <div className="h-1.5 w-20 rounded bg-slate-600 mb-3" />
        <div className="flex items-end gap-1.5 h-16">
          {bars.map((h, i) => (
            <motion.div
              key={i}
              initial={{ height: 0 }}
              animate={{ height: `${h}%` }}
              transition={{ duration: 0.7, delay: 0.9 + i * 0.08, ease: "easeOut" }}
              className="flex-1 rounded-t-sm bg-gradient-to-t from-electric to-laser/70"
            />
          ))}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-2">
          <div className="h-8 rounded-lg bg-white/[0.03] border border-white/5" />
          <div className="h-8 rounded-lg bg-white/[0.03] border border-white/5" />
        </div>
      </div>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 30, rotate: 6 }}
      animate={{ opacity: 1, y: 0, rotate: 6 }}
      transition={{ duration: 0.8, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="absolute right-0 bottom-0 sm:right-2"
    >
      <PhoneFrame accent="#00F0FF">
        <div className="flex h-full flex-col px-3 pt-4">
          <div className="h-1.5 w-14 rounded bg-slate-500/70 mb-3" />
          <div className="space-y-2 flex-1">
            {[0, 1, 2].map((i) => (
              <div key={i} className="h-8 rounded-lg bg-white/[0.04] border border-white/5 flex items-center px-2 gap-2">
                <div className="h-4 w-4 rounded-full bg-laser/30" />
                <div className="h-1.5 w-14 rounded bg-slate-600" />
              </div>
            ))}
          </div>
          <div className="h-8 mb-4 rounded-full bg-electric flex items-center justify-center text-[9px] font-medium text-white">
            Get Started
          </div>
        </div>
      </PhoneFrame>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 1.3 }}
      className="absolute left-2 bottom-2 sm:left-6 w-40 rounded-xl border border-laser/30 bg-[#05060c]/95 p-3 font-mono text-[9px] text-laser shadow-xl backdrop-blur-xl"
      data-testid="hero-status-badge"
    >
      <div className="text-slate-500">// status</div>
      <div className="flex items-center gap-1.5 mt-1.5">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
        </span>
        <span className="text-emerald-400">Available for new projects</span>
      </div>
    </motion.div>
  </div>
);
